module.exports = __webpack_public_path__ + "static/media/Vladimir_0.797e5503.jpg";